import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxStripeModule } from 'ngx-stripe';
import { Routes, RouterModule } from '@angular/router'; 
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ParallaxModule, ParallaxConfig } from 'ngx-parallax';
import 'hammerjs';
// import { IntercomModule } from 'ng-intercom';
import { GtagModule } from 'angular-gtag';


//App Defined
import { AppComponent } from './app.component';
import { SignInComponent } from './signIn/signIn.component';
import { RequestDemoComponent } from './requestDemo/requestDemo.component';
import { ResetPasswordComponent } from './resetPassword/resetPassword.component';
import { ConfirmPasswordComponent } from './confirmPassword/confirmPassword.component';
import { ParallaxComponent } from './parallax/parallax.component';
import { BillingPortalComponent } from './billingPortal/billingPortal.component';
import { BillingPortalService } from './billingPortal/billingPortal.service';


const appRoutes: Routes = [
  { path: '', redirectTo: '/sign_in', pathMatch: 'full'},

  { path: 'sign_in', component: SignInComponent },
  { path: 'request_demo', component: RequestDemoComponent },
  { path: 'sign_up', redirectTo: '/request_demo', pathMatch: 'full' },
  { path: 'reset_password', component: ResetPasswordComponent },
  { path: 'confirm_password', component: ConfirmPasswordComponent },
  { path: 'billing_portal', component: BillingPortalComponent },
  { path: '**', redirectTo: '/sign_in', pathMatch: 'full' }

]

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    ParallaxComponent,
    RequestDemoComponent,
    ResetPasswordComponent,
    ConfirmPasswordComponent,
    BillingPortalComponent

  ],
  imports: [BrowserModule,FormsModule, ReactiveFormsModule, NgxStripeModule.forRoot(), RouterModule.forRoot(appRoutes), HttpClientModule, BrowserAnimationsModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      closeButton: true
    }),
    ParallaxModule,
    // IntercomModule.forRoot({appId: "tcvjsnrb", updateOnRouterChange: true }),
    GtagModule.forRoot({ trackingId: 'UA-156436848-1', trackPageviews: true })],
  providers: [Title, BillingPortalService],
  bootstrap: [AppComponent]
})

export class AppModule { }



